export const Container = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={`max-w-7xl mx-auto px-5 md:px-10 lg-px-15 ${className || ""}`}
    >
      {children}
    </div>
  );
};
